<tidy-popup-overlay
  [isOpen]="!!type"
  [title]="title"
  [position]="'bottom'"
  [maxHeight]="'70vh'"
  (closed)="onClose()">
  @switch (type) {
    @case ('weather') {
      <div class="modal-quick-actions">
        <button class="modal-action-btn" (click)="onQuickAction('snow-removal')">
          <span class="material-icons">ac_unit</span>
          Snow Removal
        </button>
      </div>
      @if (isLoading && !locationData) {
        <div class="modal-loading">
          <ion-spinner name="crescent" />
          <span>Loading weather data...</span>
        </div>
      } @else if (locationData?.attributes?.weather?.data) {
        <div class="modal-data-item">
          <span class="modal-data-label">Conditions</span>
          <span class="modal-data-value">{{ locationData.attributes.weather.data.conditions || 'N/A' }}</span>
        </div>
        <div class="modal-data-item">
          <span class="modal-data-label">Temperature</span>
          <span class="modal-data-value">{{ locationData.attributes.weather.data.temperature }}°F</span>
        </div>
        <div class="modal-data-item">
          <span class="modal-data-label">Humidity</span>
          <span class="modal-data-value">{{ locationData.attributes.weather.data.humidity }}%</span>
        </div>
        @if (locationData.attributes.weather.data.wind) {
          <div class="modal-data-item">
            <span class="modal-data-label">Wind</span>
            <span class="modal-data-value">{{ locationData.attributes.weather.data.wind.speed }} mph {{ locationData.attributes.weather.data.wind.direction }}</span>
          </div>
        }
      } @else {
        <div class="modal-no-data">No weather data available</div>
      }
    }
    @case ('pests') {
      <div class="modal-quick-actions">
        <button class="modal-action-btn" (click)="onQuickAction('pest-removal')">
          <span class="material-icons">pest_control</span>
          Pest Removal
        </button>
      </div>
      <div class="modal-no-data">No pest data available</div>
    }
    @case ('utilities') {
      <div class="modal-quick-actions">
        <button class="modal-action-btn" (click)="onQuickAction('report-outage')">
          <span class="material-icons">power_off</span>
          Report Outage
        </button>
      </div>
      @if (isLoading && !locationData) {
        <div class="modal-loading">
          <ion-spinner name="crescent" />
          <span>Loading utilities data...</span>
        </div>
      } @else {
        @if (locationData?.attributes?.utility?.data?.electric) {
          <div class="modal-section">
            <div class="modal-section-header">
              <span class="material-icons">bolt</span>
              <span>Electric</span>
            </div>
            <div class="modal-data-item">
              <span class="modal-data-label">Provider</span>
              <span class="modal-data-value">{{ locationData.attributes.utility.data.electric.provider || 'N/A' }}</span>
            </div>
          </div>
        }
        @if (locationData?.attributes?.utility?.data?.water) {
          <div class="modal-section">
            <div class="modal-section-header">
              <span class="material-icons">water_drop</span>
              <span>Water</span>
            </div>
            <div class="modal-data-item">
              <span class="modal-data-label">Provider</span>
              <span class="modal-data-value">{{ locationData.attributes.utility.data.water.provider || 'N/A' }}</span>
            </div>
          </div>
        }
        @if (!hasUtilitiesData()) {
          <div class="modal-no-data">No utilities data available</div>
        }
      }
    }
    @case ('trash') {
      <div class="modal-quick-actions">
        <button class="modal-action-btn" (click)="onQuickAction('large-item')">
          <span class="material-icons">delete_sweep</span>
          Large Item Pickup
        </button>
        <button class="modal-action-btn" (click)="onQuickAction('other-pickup')">
          <span class="material-icons">local_shipping</span>
          Other Pickup
        </button>
      </div>
      @if (locationData?.attributes?.utility?.data?.trash) {
        <div class="modal-data-item">
          <span class="modal-data-label">Provider</span>
          <span class="modal-data-value">{{ locationData.attributes.utility.data.trash.provider || 'N/A' }}</span>
        </div>
        @if (locationData.attributes.utility.data.trash.pickup_day) {
          <div class="modal-data-item">
            <span class="modal-data-label">Pickup Day</span>
            <span class="modal-data-value">{{ locationData.attributes.utility.data.trash.pickup_day }}</span>
          </div>
        }
      } @else {
        <div class="modal-no-data">No trash data available</div>
      }
    }
    @case ('ordinances') {
      <div class="modal-quick-actions">
        <button class="modal-action-btn" (click)="onQuickAction('request-permit')">
          <span class="material-icons">assignment</span>
          Request Permit
        </button>
      </div>
      @if (hasOrdinancesData()) {
        <div class="modal-ordinances">
          @for (item of getOrdinancesSummary(); track item.category) {
            <div class="modal-ordinance-row">
              <div class="modal-ordinance-category">
                <span class="material-icons">{{ item.icon }}</span>
                <span>{{ item.category }}</span>
              </div>
              <div class="modal-ordinance-summary">{{ item.summary }}</div>
            </div>
          }
        </div>
      } @else {
        <div class="modal-no-data">No ordinances data available</div>
      }
    }
  }
</tidy-popup-overlay>
